import Vue from 'vue';
import App from './App.vue';
import store from '@/store/index';
import router from '@/plugins/router';
import vuetify from '@/plugins/vuetify';
// import initMyMicroApp from 'v-micro-app-plugin';
import microApp from '@micro-zoe/micro-app';

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

microApp.start();

app.$mount('#app');

// const options = {
//   projectName: 'v-micro-app-plugin',
//   // subAppConfigs: {
//   //     appFirst: {
//   //         name: 'appFirst',
//   //         url: 'https://unify.bds188.com/demo/index.html', // 微应用的运行地址
//   //     },
//   // },
//   isBaseApp: true, // 当前应用是否为主应用
//   basePath: '/', // 打包路径或其他基础路径
//   disableSandbox: false, // 是否禁用沙箱
//   iframe: true, // 是否使用 iframe
// };
// // 初始化微前端插件
// initMyMicroApp(app, options, router, store).then(() => {
//   app.$mount('#app');
// });

